import React from "react";
import { useQuery } from "react-query";
import { Switch } from "react-router-dom";
import Loader from "../loader/Loader";
import Header from "./header/Header";
import MobileMenu from "./mobileMenu/MobileMenu";
import RouteWithSubRoutes from "app/utils/RouteWithSubRoutes";
import { useGet } from "app/services/http-service";
import { CLIENT_CONFIG, DOWNLOAD_IMAGE } from "app/api/ApiEndpoints";
import Themes from "app/styles/theme/Themes";
import { StoreContext } from "app/context/Store";
import { CLIENT_CONFIG_DETAILS } from "app/context/Types";
import "./header/header.css";
import SideNavigationMobile from "./sidenavigation/sidenavmobile";
// import { isMobile } from "app/utils/isMobile";
import SideNavigation from "./sidenavigation/SideNavigation";
import useWindowSize from "app/hooks/useWindowSize";

function MainLayout(props) {
  const { route } = props;
  const [width] = useWindowSize();
  const context = React.useContext(StoreContext);
  const isHideHeader = localStorage.getItem("isHideHeader");
  const themeName = localStorage.getItem("theme");
  const { data: clientConfigData, isSuccess: fetchedClientConfigData } =
    useQuery("fetchedClientConfigData", () => useGet({ url: CLIENT_CONFIG }));

  React.useEffect(() => {
    if (isHideHeader === "true") {
      document.body.classList.add("iframe-app");
    }
  }, [isHideHeader]);

  React.useEffect(() => {
    if (fetchedClientConfigData && clientConfigData) {
      const fontName = clientConfigData?.clientConfigs?.find(
        (item) => item.name === "--font-name",
      );
      if (fontName && fontName.value) {
        const r = document.querySelector(":root");
        r.style.setProperty("--font-family", fontName.value);
      }
      context.dispatch({
        type: CLIENT_CONFIG_DETAILS,
        payload: { ...context.state, clientConfigData: clientConfigData },
      });
    }
  }, [fetchedClientConfigData, clientConfigData]);

  React.useEffect(() => {
    if (Themes[themeName]) {
      for (var key in Themes[themeName]) {
        if (
          context?.state?.clientConfigData &&
          Themes[themeName].hasOwnProperty(key)
        ) {
          const colorCode = context?.state?.clientConfigData?.clientConfigs
            .filter((data) => data.name === key)
            .map((val) => val.value);
          const themeValue =
            colorCode !== undefined
              ? colorCode.toString()
              : Themes[themeName][key];
          document.documentElement.style.setProperty(key, themeValue);
        }
      }
    }
  }, [Themes, themeName, context?.state?.clientConfigData]);

  React.useEffect(() => {
    if (sessionStorage.getItem("tenant-name") === localStorage.getItem("currentTenantName")) {
      const savedTitle = sessionStorage.getItem('app_title');
      const savedLogo = sessionStorage.getItem('app_logo');

      if (savedTitle) {
        document.title = savedTitle;
      }

      if (savedLogo) {
        const favicon = document.querySelector('link[rel="icon"]');
        if (favicon) {
          favicon.href = `${DOWNLOAD_IMAGE}?key=${savedLogo}`;
        }
      }
    }
  }, []);


  return (
    <>
      {isHideHeader !== "true" && <Header />}
      {clientConfigData && (
        <>
          <section className="section-wrapper">
            {
              width < 700 ? <SideNavigationMobile /> : <SideNavigation />
            }
            <React.Suspense fallback={<Loader loaderMessage="Loading..." />}>
              <Switch>
                {route?.routes.map((route, index) => (
                  <RouteWithSubRoutes key={index} {...route} />
                ))}
              </Switch>
            </React.Suspense>
          </section>
          <MobileMenu />
        </>
      )}
    </>
  );
}

export default MainLayout;
